import React from 'react';

import combinedActions from '~redux/combinedActions';
import { useAppDispatch, useAppSelector } from '~redux/hooks';
import { TGetBranchListingFilters } from '~types/feat/branch';

import SearchAndFilterBar, { TSearchAndFilterBarProps } from '~components/molecules/SearchAndFilterBar';

import * as Styles from './_branchesApprovalTableSearchAndFilterBar.module.scss';

const BranchesApprovalTableSearchAndFilterBar = () => {
    const filters = useAppSelector(state => state.approval.pendingBranchesListing.filters);

    const dispatch = useAppDispatch();

    const setFilters = (inputFilters: TGetBranchListingFilters) => dispatch(combinedActions.approvalSetBranchesListingFilters(inputFilters));
    const handleSearchClick = () => dispatch(combinedActions.approvalGetPendingBranchesListingAttempt());
    const handleCancelClick = () => {
        dispatch(combinedActions.approvalClearPendingBranchesListingFilters());
        dispatch(combinedActions.approvalGetPendingBranchesListingAttempt());
    };

    const regionList = useAppSelector(state => state.branch.allRegions);

    const massagedBranchesListOption = () => {
        if (!regionList.length) return [];

        return regionList.map((region) => ({
            label: region.regionName,
            value: region.regionId,
        }));
    };

    const fields: TSearchAndFilterBarProps['fields'] = [
        {
            label: 'Region:',
            type: 'dropdown' as const,
            dropdownParams: {
                options: massagedBranchesListOption(),
                value: filters.regionName || '',
                setValue: (event: React.ChangeEvent<HTMLInputElement>) => {
                    setFilters({
                        ...filters,
                        regionName: event.target.value || '',
                    });
                },
                optionSelected: !!regionList.find((region) => region.regionName === filters.regionName),
                noOptionsMessage: 'No region found',
                className: Styles.dropdown,
            },
        },
    ];

    return (
        <SearchAndFilterBar
            fields={fields}
            searchOnClick={handleSearchClick}
            cancelOnClick={handleCancelClick}
            containerClassName={Styles['content-container']}
        />
    );
};

export default BranchesApprovalTableSearchAndFilterBar;
